import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import Layout from "../components/Layout";
const Billing = () => {
    return (_jsxs(Layout, { children: [_jsx(Typography, Object.assign({ variant: "h6" }, { children: "Billing" })), _jsx(Typography, { children: "Don't worry about this! You are not being charged" })] }));
};
export default Billing;
